// extracted by mini-css-extract-plugin
module.exports = {"emailSideTab":"az_r9","expanded":"az_s9","disappear":"az_t9"};